export default {
  issuerInfo: {},
  issuerId: '',
  issuerWalletManagers: {},
  currentToken: {},
  permissionsPerIssuer: {},
};
